import navigationConfig from "../../../../../configs/navigationConfig";

export const getFirstParentNavigation = (parent) => {
  let parent1 = navigationConfig().find((item) => {
    return item.id === parent;
  });
  if (!parent1) {
    parent1 = navigationConfig().find((item) => {
      if (item.type === "collapse") {
        return item.children.map((child) => child.id).includes(parent);
      }
    });
  }
  return parent1;
};
